import { render } from "./BaseButton.vue?vue&type=template&id=e9f10aa6&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=e9f10aa6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e9f10aa6"

export default script